[
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "authority",
        "type": "address"
      }
    ],
    "name": "AccessManagedInvalidAuthority",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "caller",
        "type": "address"
      },
      {
        "internalType": "uint32",
        "name": "delay",
        "type": "uint32"
      }
    ],
    "name": "AccessManagedRequiredDelay",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "caller",
        "type": "address"
      }
    ],
    "name": "AccessManagedUnauthorized",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "target",
        "type": "address"
      }
    ],
    "name": "AddressEmptyCode",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "sender",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "balance",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "needed",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "ERC1155InsufficientBalance",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "approver",
        "type": "address"
      }
    ],
    "name": "ERC1155InvalidApprover",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "idsLength",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "valuesLength",
        "type": "uint256"
      }
    ],
    "name": "ERC1155InvalidArrayLength",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      }
    ],
    "name": "ERC1155InvalidOperator",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "receiver",
        "type": "address"
      }
    ],
    "name": "ERC1155InvalidReceiver",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "sender",
        "type": "address"
      }
    ],
    "name": "ERC1155InvalidSender",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "ERC1155MissingApprovalForAll",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "implementation",
        "type": "address"
      }
    ],
    "name": "ERC1967InvalidImplementation",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "ERC1967NonPayable",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "numerator",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "denominator",
        "type": "uint256"
      }
    ],
    "name": "ERC2981InvalidDefaultRoyalty",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "receiver",
        "type": "address"
      }
    ],
    "name": "ERC2981InvalidDefaultRoyaltyReceiver",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "numerator",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "denominator",
        "type": "uint256"
      }
    ],
    "name": "ERC2981InvalidTokenRoyalty",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "receiver",
        "type": "address"
      }
    ],
    "name": "ERC2981InvalidTokenRoyaltyReceiver",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "FailedInnerCall",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address[]",
        "name": "tos",
        "type": "address[]"
      },
      {
        "internalType": "uint256[]",
        "name": "ids",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "amounts",
        "type": "uint256[]"
      }
    ],
    "name": "InvalidBatchMint",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address[]",
        "name": "tos",
        "type": "address[]"
      },
      {
        "internalType": "uint256[]",
        "name": "ids",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "amounts",
        "type": "uint256[]"
      }
    ],
    "name": "InvalidBatchReveal",
    "type": "error"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint64",
            "name": "maxMint",
            "type": "uint64"
          },
          {
            "internalType": "uint8",
            "name": "minAmount",
            "type": "uint8"
          },
          {
            "components": [
              {
                "internalType": "address",
                "name": "collection",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "templateId",
                "type": "uint256"
              },
              {
                "internalType": "uint16",
                "name": "probability",
                "type": "uint16"
              }
            ],
            "internalType": "struct Pack.Probability[]",
            "name": "probabilities",
            "type": "tuple[]"
          },
          {
            "internalType": "uint16",
            "name": "distributionProbability",
            "type": "uint16"
          },
          {
            "internalType": "uint256",
            "name": "minted",
            "type": "uint256"
          }
        ],
        "internalType": "struct Pack.Distribution",
        "name": "distribution",
        "type": "tuple"
      }
    ],
    "name": "InvalidDistributionNoProbabilities",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidInitialization",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "InvalidMint",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      }
    ],
    "name": "InvalidPackId",
    "type": "error"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint64",
            "name": "maxSupply",
            "type": "uint64"
          },
          {
            "internalType": "uint8",
            "name": "amountOfTokens",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "minted",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint64",
                "name": "maxMint",
                "type": "uint64"
              },
              {
                "internalType": "uint8",
                "name": "minAmount",
                "type": "uint8"
              },
              {
                "components": [
                  {
                    "internalType": "address",
                    "name": "collection",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "templateId",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint16",
                    "name": "probability",
                    "type": "uint16"
                  }
                ],
                "internalType": "struct Pack.Probability[]",
                "name": "probabilities",
                "type": "tuple[]"
              },
              {
                "internalType": "uint16",
                "name": "distributionProbability",
                "type": "uint16"
              },
              {
                "internalType": "uint256",
                "name": "minted",
                "type": "uint256"
              }
            ],
            "internalType": "struct Pack.Distribution[]",
            "name": "distributions",
            "type": "tuple[]"
          }
        ],
        "internalType": "struct Pack.Pack",
        "name": "pack",
        "type": "tuple"
      }
    ],
    "name": "InvalidPackNoDistributions",
    "type": "error"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint64",
            "name": "maxSupply",
            "type": "uint64"
          },
          {
            "internalType": "uint8",
            "name": "amountOfTokens",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "minted",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint64",
                "name": "maxMint",
                "type": "uint64"
              },
              {
                "internalType": "uint8",
                "name": "minAmount",
                "type": "uint8"
              },
              {
                "components": [
                  {
                    "internalType": "address",
                    "name": "collection",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "templateId",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint16",
                    "name": "probability",
                    "type": "uint16"
                  }
                ],
                "internalType": "struct Pack.Probability[]",
                "name": "probabilities",
                "type": "tuple[]"
              },
              {
                "internalType": "uint16",
                "name": "distributionProbability",
                "type": "uint16"
              },
              {
                "internalType": "uint256",
                "name": "minted",
                "type": "uint256"
              }
            ],
            "internalType": "struct Pack.Distribution[]",
            "name": "distributions",
            "type": "tuple[]"
          }
        ],
        "internalType": "struct Pack.Pack",
        "name": "pack",
        "type": "tuple"
      }
    ],
    "name": "InvalidPackNoTokens",
    "type": "error"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint64",
            "name": "maxSupply",
            "type": "uint64"
          },
          {
            "internalType": "uint8",
            "name": "amountOfTokens",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "minted",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint64",
                "name": "maxMint",
                "type": "uint64"
              },
              {
                "internalType": "uint8",
                "name": "minAmount",
                "type": "uint8"
              },
              {
                "components": [
                  {
                    "internalType": "address",
                    "name": "collection",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "templateId",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint16",
                    "name": "probability",
                    "type": "uint16"
                  }
                ],
                "internalType": "struct Pack.Probability[]",
                "name": "probabilities",
                "type": "tuple[]"
              },
              {
                "internalType": "uint16",
                "name": "distributionProbability",
                "type": "uint16"
              },
              {
                "internalType": "uint256",
                "name": "minted",
                "type": "uint256"
              }
            ],
            "internalType": "struct Pack.Distribution[]",
            "name": "distributions",
            "type": "tuple[]"
          }
        ],
        "internalType": "struct Pack.Pack",
        "name": "pack",
        "type": "tuple"
      },
      {
        "components": [
          {
            "internalType": "bytes32",
            "name": "entropy",
            "type": "bytes32"
          },
          {
            "internalType": "uint256",
            "name": "index",
            "type": "uint256"
          },
          {
            "internalType": "uint16",
            "name": "number",
            "type": "uint16"
          },
          {
            "internalType": "uint256",
            "name": "tokens",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "distributionsLength",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "currentMinted",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "probabilitiesLength",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "probability",
            "type": "uint256"
          },
          {
            "internalType": "uint16",
            "name": "distributionProbability",
            "type": "uint16"
          },
          {
            "internalType": "uint256",
            "name": "j",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint256",
                "name": "packId",
                "type": "uint256"
              },
              {
                "internalType": "address",
                "name": "collection",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "templateId",
                "type": "uint256"
              },
              {
                "internalType": "address",
                "name": "receiver",
                "type": "address"
              }
            ],
            "internalType": "struct Pack.Reveal[]",
            "name": "reveals",
            "type": "tuple[]"
          }
        ],
        "internalType": "struct Pack.RevealState",
        "name": "state",
        "type": "tuple"
      }
    ],
    "name": "InvalidPackReveal",
    "type": "error"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint64",
            "name": "maxSupply",
            "type": "uint64"
          },
          {
            "internalType": "uint8",
            "name": "amountOfTokens",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "minted",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint64",
                "name": "maxMint",
                "type": "uint64"
              },
              {
                "internalType": "uint8",
                "name": "minAmount",
                "type": "uint8"
              },
              {
                "components": [
                  {
                    "internalType": "address",
                    "name": "collection",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "templateId",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint16",
                    "name": "probability",
                    "type": "uint16"
                  }
                ],
                "internalType": "struct Pack.Probability[]",
                "name": "probabilities",
                "type": "tuple[]"
              },
              {
                "internalType": "uint16",
                "name": "distributionProbability",
                "type": "uint16"
              },
              {
                "internalType": "uint256",
                "name": "minted",
                "type": "uint256"
              }
            ],
            "internalType": "struct Pack.Distribution[]",
            "name": "distributions",
            "type": "tuple[]"
          }
        ],
        "internalType": "struct Pack.Pack",
        "name": "pack",
        "type": "tuple"
      }
    ],
    "name": "InvalidPackTotalMinAmount",
    "type": "error"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint64",
            "name": "maxSupply",
            "type": "uint64"
          },
          {
            "internalType": "uint8",
            "name": "amountOfTokens",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "minted",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint64",
                "name": "maxMint",
                "type": "uint64"
              },
              {
                "internalType": "uint8",
                "name": "minAmount",
                "type": "uint8"
              },
              {
                "components": [
                  {
                    "internalType": "address",
                    "name": "collection",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "templateId",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint16",
                    "name": "probability",
                    "type": "uint16"
                  }
                ],
                "internalType": "struct Pack.Probability[]",
                "name": "probabilities",
                "type": "tuple[]"
              },
              {
                "internalType": "uint16",
                "name": "distributionProbability",
                "type": "uint16"
              },
              {
                "internalType": "uint256",
                "name": "minted",
                "type": "uint256"
              }
            ],
            "internalType": "struct Pack.Distribution[]",
            "name": "distributions",
            "type": "tuple[]"
          }
        ],
        "internalType": "struct Pack.Pack",
        "name": "pack",
        "type": "tuple"
      }
    ],
    "name": "InvalidPackTotalProbability",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "InvalidReveal",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotInitializing",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "UUPSUnauthorizedCallContext",
    "type": "error"
  },
  {
    "inputs": [
      {
        "internalType": "bytes32",
        "name": "slot",
        "type": "bytes32"
      }
    ],
    "name": "UUPSUnsupportedProxiableUUID",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "ApprovalForAll",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "address",
        "name": "authority",
        "type": "address"
      }
    ],
    "name": "AuthorityUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [],
    "name": "ContractURIUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint64",
        "name": "version",
        "type": "uint64"
      }
    ],
    "name": "Initialized",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "packId",
        "type": "uint256"
      },
      {
        "components": [
          {
            "internalType": "uint64",
            "name": "maxSupply",
            "type": "uint64"
          },
          {
            "internalType": "uint8",
            "name": "amountOfTokens",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "minted",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint64",
                "name": "maxMint",
                "type": "uint64"
              },
              {
                "internalType": "uint8",
                "name": "minAmount",
                "type": "uint8"
              },
              {
                "components": [
                  {
                    "internalType": "address",
                    "name": "collection",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "templateId",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint16",
                    "name": "probability",
                    "type": "uint16"
                  }
                ],
                "internalType": "struct Pack.Probability[]",
                "name": "probabilities",
                "type": "tuple[]"
              },
              {
                "internalType": "uint16",
                "name": "distributionProbability",
                "type": "uint16"
              },
              {
                "internalType": "uint256",
                "name": "minted",
                "type": "uint256"
              }
            ],
            "internalType": "struct Pack.Distribution[]",
            "name": "distributions",
            "type": "tuple[]"
          }
        ],
        "indexed": false,
        "internalType": "struct Pack.Pack",
        "name": "pack",
        "type": "tuple"
      }
    ],
    "name": "PackCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "packId",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "collection",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "templateId",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "receiver",
            "type": "address"
          }
        ],
        "indexed": false,
        "internalType": "struct Pack.Reveal[]",
        "name": "reveals",
        "type": "tuple[]"
      }
    ],
    "name": "PackRevealed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "packId",
        "type": "uint256"
      },
      {
        "components": [
          {
            "internalType": "uint64",
            "name": "maxSupply",
            "type": "uint64"
          },
          {
            "internalType": "uint8",
            "name": "amountOfTokens",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "minted",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint64",
                "name": "maxMint",
                "type": "uint64"
              },
              {
                "internalType": "uint8",
                "name": "minAmount",
                "type": "uint8"
              },
              {
                "components": [
                  {
                    "internalType": "address",
                    "name": "collection",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "templateId",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint16",
                    "name": "probability",
                    "type": "uint16"
                  }
                ],
                "internalType": "struct Pack.Probability[]",
                "name": "probabilities",
                "type": "tuple[]"
              },
              {
                "internalType": "uint16",
                "name": "distributionProbability",
                "type": "uint16"
              },
              {
                "internalType": "uint256",
                "name": "minted",
                "type": "uint256"
              }
            ],
            "internalType": "struct Pack.Distribution[]",
            "name": "distributions",
            "type": "tuple[]"
          }
        ],
        "indexed": false,
        "internalType": "struct Pack.Pack",
        "name": "pack",
        "type": "tuple"
      }
    ],
    "name": "PackUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256[]",
        "name": "ids",
        "type": "uint256[]"
      },
      {
        "indexed": false,
        "internalType": "uint256[]",
        "name": "values",
        "type": "uint256[]"
      }
    ],
    "name": "TransferBatch",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      }
    ],
    "name": "TransferSingle",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "string",
        "name": "value",
        "type": "string"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      }
    ],
    "name": "URI",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "implementation",
        "type": "address"
      }
    ],
    "name": "Upgraded",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "UPGRADE_INTERFACE_VERSION",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "authority",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address[]",
        "name": "accounts",
        "type": "address[]"
      },
      {
        "internalType": "uint256[]",
        "name": "ids",
        "type": "uint256[]"
      }
    ],
    "name": "balanceOfBatch",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      }
    ],
    "name": "burn",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "uint256[]",
        "name": "ids",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "values",
        "type": "uint256[]"
      }
    ],
    "name": "burnBatch",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "contractURI",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint64",
            "name": "maxSupply",
            "type": "uint64"
          },
          {
            "internalType": "uint8",
            "name": "amountOfTokens",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "minted",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint64",
                "name": "maxMint",
                "type": "uint64"
              },
              {
                "internalType": "uint8",
                "name": "minAmount",
                "type": "uint8"
              },
              {
                "components": [
                  {
                    "internalType": "address",
                    "name": "collection",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "templateId",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint16",
                    "name": "probability",
                    "type": "uint16"
                  }
                ],
                "internalType": "struct Pack.Probability[]",
                "name": "probabilities",
                "type": "tuple[]"
              },
              {
                "internalType": "uint16",
                "name": "distributionProbability",
                "type": "uint16"
              },
              {
                "internalType": "uint256",
                "name": "minted",
                "type": "uint256"
              }
            ],
            "internalType": "struct Pack.Distribution[]",
            "name": "distributions",
            "type": "tuple[]"
          }
        ],
        "internalType": "struct Pack.Pack",
        "name": "pack",
        "type": "tuple"
      }
    ],
    "name": "createPack",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      }
    ],
    "name": "exists",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      }
    ],
    "name": "getPack",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint64",
            "name": "maxSupply",
            "type": "uint64"
          },
          {
            "internalType": "uint8",
            "name": "amountOfTokens",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "minted",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint64",
                "name": "maxMint",
                "type": "uint64"
              },
              {
                "internalType": "uint8",
                "name": "minAmount",
                "type": "uint8"
              },
              {
                "components": [
                  {
                    "internalType": "address",
                    "name": "collection",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "templateId",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint16",
                    "name": "probability",
                    "type": "uint16"
                  }
                ],
                "internalType": "struct Pack.Probability[]",
                "name": "probabilities",
                "type": "tuple[]"
              },
              {
                "internalType": "uint16",
                "name": "distributionProbability",
                "type": "uint16"
              },
              {
                "internalType": "uint256",
                "name": "minted",
                "type": "uint256"
              }
            ],
            "internalType": "struct Pack.Distribution[]",
            "name": "distributions",
            "type": "tuple[]"
          }
        ],
        "internalType": "struct Pack.Pack",
        "name": "pack",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "initialAuthority",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "royaltyReceiver",
        "type": "address"
      },
      {
        "internalType": "uint96",
        "name": "royaltyFeeNumerator",
        "type": "uint96"
      }
    ],
    "name": "initialize",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      }
    ],
    "name": "isApprovedForAll",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "isConsumingScheduledOp",
    "outputs": [
      {
        "internalType": "bytes4",
        "name": "",
        "type": "bytes4"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }
    ],
    "name": "mint",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address[]",
        "name": "tos",
        "type": "address[]"
      },
      {
        "internalType": "uint256[]",
        "name": "ids",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "amounts",
        "type": "uint256[]"
      },
      {
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }
    ],
    "name": "mintBatch",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "name",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "nextPackId",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "proxiableUUID",
    "outputs": [
      {
        "internalType": "bytes32",
        "name": "",
        "type": "bytes32"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }
    ],
    "name": "reveal",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "packId",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "collection",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "templateId",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "receiver",
            "type": "address"
          }
        ],
        "internalType": "struct Pack.Reveal[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address[]",
        "name": "tos",
        "type": "address[]"
      },
      {
        "internalType": "uint256[]",
        "name": "ids",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "amounts",
        "type": "uint256[]"
      },
      {
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }
    ],
    "name": "revealBatch",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "salePrice",
        "type": "uint256"
      }
    ],
    "name": "royaltyInfo",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256[]",
        "name": "ids",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "values",
        "type": "uint256[]"
      },
      {
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }
    ],
    "name": "safeBatchTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "value",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }
    ],
    "name": "safeTransferFrom",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "operator",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "approved",
        "type": "bool"
      }
    ],
    "name": "setApprovalForAll",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newAuthority",
        "type": "address"
      }
    ],
    "name": "setAuthority",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "contractURI_",
        "type": "string"
      }
    ],
    "name": "setContractURI",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "receiver",
        "type": "address"
      },
      {
        "internalType": "uint96",
        "name": "feeNumerator",
        "type": "uint96"
      }
    ],
    "name": "setTokenRoyalty",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "packId",
        "type": "uint256"
      },
      {
        "internalType": "string",
        "name": "uri_",
        "type": "string"
      }
    ],
    "name": "setURI",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint64",
            "name": "maxSupply",
            "type": "uint64"
          },
          {
            "internalType": "uint8",
            "name": "amountOfTokens",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "minted",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint64",
                "name": "maxMint",
                "type": "uint64"
              },
              {
                "internalType": "uint8",
                "name": "minAmount",
                "type": "uint8"
              },
              {
                "components": [
                  {
                    "internalType": "address",
                    "name": "collection",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "templateId",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint16",
                    "name": "probability",
                    "type": "uint16"
                  }
                ],
                "internalType": "struct Pack.Probability[]",
                "name": "probabilities",
                "type": "tuple[]"
              },
              {
                "internalType": "uint16",
                "name": "distributionProbability",
                "type": "uint16"
              },
              {
                "internalType": "uint256",
                "name": "minted",
                "type": "uint256"
              }
            ],
            "internalType": "struct Pack.Distribution[]",
            "name": "distributions",
            "type": "tuple[]"
          }
        ],
        "internalType": "struct Pack.Pack",
        "name": "pack",
        "type": "tuple"
      },
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }
    ],
    "name": "simulate",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint64",
            "name": "maxSupply",
            "type": "uint64"
          },
          {
            "internalType": "uint8",
            "name": "amountOfTokens",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "minted",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint64",
                "name": "maxMint",
                "type": "uint64"
              },
              {
                "internalType": "uint8",
                "name": "minAmount",
                "type": "uint8"
              },
              {
                "components": [
                  {
                    "internalType": "address",
                    "name": "collection",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "templateId",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint16",
                    "name": "probability",
                    "type": "uint16"
                  }
                ],
                "internalType": "struct Pack.Probability[]",
                "name": "probabilities",
                "type": "tuple[]"
              },
              {
                "internalType": "uint16",
                "name": "distributionProbability",
                "type": "uint16"
              },
              {
                "internalType": "uint256",
                "name": "minted",
                "type": "uint256"
              }
            ],
            "internalType": "struct Pack.Distribution[]",
            "name": "distributions",
            "type": "tuple[]"
          }
        ],
        "internalType": "struct Pack.Pack",
        "name": "",
        "type": "tuple"
      },
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "packId",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "collection",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "templateId",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "receiver",
            "type": "address"
          }
        ],
        "internalType": "struct Pack.Reveal[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes4",
        "name": "interfaceId",
        "type": "bytes4"
      }
    ],
    "name": "supportsInterface",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "symbol",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "pure",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalSupply",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      }
    ],
    "name": "totalSupply",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "packId",
        "type": "uint256"
      },
      {
        "components": [
          {
            "internalType": "uint64",
            "name": "maxSupply",
            "type": "uint64"
          },
          {
            "internalType": "uint8",
            "name": "amountOfTokens",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "minted",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "uint64",
                "name": "maxMint",
                "type": "uint64"
              },
              {
                "internalType": "uint8",
                "name": "minAmount",
                "type": "uint8"
              },
              {
                "components": [
                  {
                    "internalType": "address",
                    "name": "collection",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "templateId",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint16",
                    "name": "probability",
                    "type": "uint16"
                  }
                ],
                "internalType": "struct Pack.Probability[]",
                "name": "probabilities",
                "type": "tuple[]"
              },
              {
                "internalType": "uint16",
                "name": "distributionProbability",
                "type": "uint16"
              },
              {
                "internalType": "uint256",
                "name": "minted",
                "type": "uint256"
              }
            ],
            "internalType": "struct Pack.Distribution[]",
            "name": "distributions",
            "type": "tuple[]"
          }
        ],
        "internalType": "struct Pack.Pack",
        "name": "pack",
        "type": "tuple"
      }
    ],
    "name": "updatePack",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newImplementation",
        "type": "address"
      },
      {
        "internalType": "bytes",
        "name": "data",
        "type": "bytes"
      }
    ],
    "name": "upgradeToAndCall",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "id",
        "type": "uint256"
      }
    ],
    "name": "uri",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
]
